export default "__VITE_ASSET__DYk5o_OS__"